import { useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import { useLanguage } from '../../context/LanguageContext';

export default function PrivacyPolicy() {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1A2B4A] mb-6">
            {t('privacyPolicy.title')}
          </h1>
          <p className="text-gray-600 mb-12">
            {t('privacyPolicy.lastUpdated')}
          </p>

          <div className="space-y-10">
            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.introTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.introText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.infoCollectTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.infoCollectText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.howUseTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.howUseText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.dataProtectionTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.dataProtectionText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.dataSharingTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.dataSharingText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.cookiesTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.cookiesText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.userRightsTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.userRightsText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.dataRetentionTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.dataRetentionText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.internationalTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.internationalText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.changesTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.changesText')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">
                {t('privacyPolicy.contactTitle')}
              </h2>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.contactText')}
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}